import React, { Component } from 'react';

import IteamToolbarContainer from './IteamToolbarContainer';
import IteamInteractionContainer from './IteamInteractionContainer';
import IteamDictionaryComponent from '../components/IteamDictionaryComponent';
import IframePopup from './IframePopup';

class IteamMiddleContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {showDictionary: false,
                      showBookAndGames: true,
                      sectionItem: null,
                      isToolbarContainerVisible: true,
                      showPopup: false,
                      popupUrl: 'https://www.teamelt.com/forstudents_5',
                    }


        this.loadBookContent = this.loadBookContent.bind(this);
        this.setToolbarContainerIsVisibleCallBack = this.setToolbarContainerIsVisibleCallBack.bind(this);
        this.closeDrawingThicknessMenuCallback = this.closeDrawingThicknessMenuCallback.bind(this);
        this.setCloseDrawingThicknessMenuHandler = this.setCloseDrawingThicknessMenuHandler.bind(this);
        this.handleClosePopup = this.handleClosePopup.bind(this);
        this.setLinkUrlCallBack = this.setLinkUrlCallBack.bind(this);

        this.iteamInteractionContainer = React.createRef();
        this.bookInteractionContainer = React.createRef();
        this.iteamToolbarContainer = React.createRef();

        this.closeDrawingThicknessMenuHandler = () => {}; // this will be overrided later, this is hack to prevent undefiend / null check

    }

    loadBookContent(sectionItem) {
        this.setState({sectionItem: sectionItem});
        if (sectionItem.type === 'dictionary') {
            this.setState({showDictionary: true});
            this.setState({showBookAndGames: false});
            this.props.setPageAudioDMHandler(null);
            this.props.setPageVideoDMHandler(null);
        } else {
            this.iteamInteractionContainer.loadBookContent(sectionItem);
            this.setState({showDictionary: false});
            this.setState({showBookAndGames: true});
        }
    }

    setToolbarContainerIsVisibleCallBack(isVisible) {
        if (isVisible) {
            this.setState({isToolbarContainerVisible: true});
        } else {
            this.setState({isToolbarContainerVisible: false});
        }
    }

    // this is called from phaser
    closeDrawingThicknessMenuCallback() {
        this.closeDrawingThicknessMenuHandler(); // it is safe to call this, it is initialized as a dummy void function, then replaced by toolbar
    }

    // this one is called to inform toolbar
    setCloseDrawingThicknessMenuHandler(handler) {
        this.closeDrawingThicknessMenuHandler = handler;
    }

    // Function to close the popup
    handleClosePopup() {
        this.setState({showPopup: false});
        this.setState({popupUrl: ''}); // Clear the URL when closing (optional, but good practice)
    };


    setLinkUrlCallBack(url) {
        this.setState({showPopup: true});
        this.setState({popupUrl: url}); // Clear the URL when closing (optional, but good practice)
    }


    render() {
        let bookInteractionContainerStyle = {display: 'none'};
        if (this.state.showBookAndGames) {
            bookInteractionContainerStyle = {display: 'flex'};
        }


        return (
            <div className='iTeamMiddleContainerWrapper'>
                {this.state.showDictionary && <IteamDictionaryComponent 
                        setHeaderTitleInfoCallback={this.props.setHeaderTitleInfoCallback}
                        sectionItem={this.state.sectionItem} />}
                <div id='iTeamMiddle' className='iTeamMiddleContainer' ref={instance => this.bookInteractionContainer = instance} style={bookInteractionContainerStyle}>
                    {this.state.isToolbarContainerVisible ? <IteamToolbarContainer ref={instance => this.iteamToolbarContainer = instance}

                            isExerciseModeActive={this.props.isExerciseModeActive}
                            
                            zoomInPageHandler={() => this.iteamInteractionContainer.pageScene.zoomInByTenPercent()}
                            zoomOutPageHandler={() => this.iteamInteractionContainer.pageScene.zoomOutByTenPercent()}
                            zoomFitWidthPageHandler={() => this.iteamInteractionContainer.pageScene.zoomFitWidth()}
                            zoomFitHeightPageHandler={() => this.iteamInteractionContainer.pageScene.zoomFitHeight()}

                            zoomInExerciseHandler={() => this.iteamInteractionContainer.exerciseScene.zoomInByTenPercent()}
                            zoomOutExerciseHandler={() => this.iteamInteractionContainer.exerciseScene.zoomOutByTenPercent()}
                            zoomFitWidthExerciseHandler={() => this.iteamInteractionContainer.exerciseScene.zoomFitWidth()}
                            zoomFitHeightExerciseHandler={() => this.iteamInteractionContainer.exerciseScene.zoomFitHeight()}

                            disableGameInputsCallback={this.props.disableGameInputsCallback}
                            enableGameInputsCallback={this.props.enableGameInputsCallback}

                            setCloseDrawingThicknessMenuHandler={this.setCloseDrawingThicknessMenuHandler}

                    /> : '' }
                    <IteamInteractionContainer ref={instance => this.iteamInteractionContainer = instance}

                        setToolbarContainerIsVisibleCallBack={this.setToolbarContainerIsVisibleCallBack}
                        setIsExerciseModeActive={this.props.setIsExerciseModeActive}
                        setUnitsCallBack={this.props.setUnitsCallBack} 
                        enableGameInputs={this.props.enableGameInputs}
                        closeDrawingThicknessMenuCallback={this.closeDrawingThicknessMenuCallback}
                        setHeaderTitleInfoCallback={this.props.setHeaderTitleInfoCallback}
                        setExerciseCloseCallback={this.props.setExerciseCloseCallback}
                        setExerciseAudioDMHandler={this.props.setExerciseAudioDMHandler}
                        setExerciseVideoDMHandler={this.props.setExerciseVideoDMHandler}
                        setPageAudioDMHandler={this.props.setPageAudioDMHandler}
                        setPageVideoDMHandler={this.props.setPageVideoDMHandler}
                        pausePageAudioCallBack={this.props.pausePageAudioCallBack}
                        pausePageVideoCallBack={this.props.pausePageVideoCallBack}
                        setLinkUrlCallBack={this.setLinkUrlCallBack}
                        />
                </div>
                {/* Conditionally render the IframePopup */}
                {this.state.showPopup && (
                    <IframePopup 
                        isOnline={this.props.isOnline} 
                        url={this.state.popupUrl} 
                        onClose={this.handleClosePopup} 
                    />
                )}
            </div>
        );
    }
}


export default IteamMiddleContainer;
